import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageBusService } from '@xdig/ng-microkernel/micro-frontend';
import { Observable, throwError } from 'rxjs';
import { catchError, filter, tap } from 'rxjs/operators';

@Injectable()
export class LoadingAnimationInterceptor implements HttpInterceptor {
  constructor(private messageBus: MessageBusService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.handleAnimation(req, next);
  }

  private handleAnimation(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.messageBus.emit('shell.animation', 'loading.begins', true);

    return next.handle(req).pipe(
      catchError((error) => {
        this.messageBus.emit('shell.animation', 'loading.ends', true);

        return throwError(error);
      }),
      filter((event) => event instanceof HttpResponse),
      tap(() => this.messageBus.emit('shell.animation', 'loading.ends', true)),
    );
  }
}
